"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "advanceFormRef",
    staticClass: "demo-form",
    attrs: {
      model: _vm.clientData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "GST",
      prop: "gstNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter GST"
    },
    model: {
      value: _vm.clientData.gstNumber,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "gstNumber", $$v);
      },
      expression: "clientData.gstNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PAN",
      prop: "panNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PAN"
    },
    model: {
      value: _vm.clientData.panNumber,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "panNumber", $$v);
      },
      expression: "clientData.panNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Website",
      prop: "website"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.clientData.website,
      callback: function ($$v) {
        _vm.$set(_vm.clientData, "website", $$v);
      },
      expression: "clientData.website"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      loading: _vm.loading,
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;